
















import {Component, Prop, Vue} from "vue-property-decorator";

export interface FaqItem {
    question: string;
    answer: string;
}

@Component
export default class FaqAccordion extends Vue {
    @Prop({type: Array, default: () => []}) items!: Array<FaqItem>;

    private openIndex: number | null = null;

    private toggleOpen(index: number) {
        this.openIndex = this.openIndex === index ? null : index;
    }

    private beforeEnter(el: any) {
        el.style.height = "0";
    }
    private enter(el: any) {
        el.style.height = el.scrollHeight + "px";
    }
    private beforeLeave(el: any) {
        el.style.height = el.scrollHeight + "px";
    }
    private leave(el: any) {
        el.style.height = "0";
    }
}
